import React from "react";
import ShoppingPng3 from "../../assets/Woman_Shopping.png";

const RegisterImage = () => {
  return (
    <div className="hidden md:flex justify-end items-start col-span-2">
      <img
        src={ShoppingPng3}
        className="max-w-md lg:max-w-xl text-center"
        alt="Register Illustration"
      />
    </div>
  );
};

export default RegisterImage;
